import Municipio from "./municipio";
class IPSView {
  public id: number;
  public nombre_ips: string;
  public cod_ips: string;
  public is_active: boolean;
  public municipio_id: Municipio;
  public date_contract: Date;
  public have_contract: boolean;
  public municipio_id__nombre_municipio:string;
  public date_update2025: Date;
  public have_lovelace: boolean
  public have_movile: boolean
  public count_movile: string
  public data_a: string
  public date_contract2026: Date;
  public comment?: string;

  constructor(
    id: number,
    nombre_ips: string,
    cod_ips: string,
    is_active: boolean,
    municipio_id: Municipio,
    date_contract: Date,
    have_contract: boolean,
    municipio_id__nombre_municipio: string,
    date_update2025: Date,
    have_lovelace: boolean,
    have_movile: boolean,
    count_movile: string,
    data_a: string,
    date_contract2026:Date
  ) {
    this.id = id;
    this.is_active = is_active;
    this.nombre_ips = nombre_ips;
    this.cod_ips = cod_ips;
    this.municipio_id = municipio_id;
    this.date_contract = date_contract;
    this.have_contract = have_contract;
    this.municipio_id__nombre_municipio = municipio_id__nombre_municipio;
    this.date_update2025 = date_update2025;
    this.have_lovelace = have_lovelace;
    this.have_movile = have_movile;
    this.count_movile = count_movile;
    this.data_a = data_a;
    this.date_contract2026 = date_contract2026
  }
}
export default IPSView;
